import useTranslation from 'next-translate/useTranslation';
import { BACKWARD_SHORTCUT_SECONDS } from 'src/components/PlayerMarkup/hooks/usePlayerEvents/constants';
import { IconSize } from 'src/interfaces/Icon';
import { RewindIcon } from '../../icons';
import { IRewindIconProps } from '../../icons/RewindIcon';
import IconButton from '../IconButton';
import TooltipWrapper from '../TooltipWrapper';

export interface IRewindControlProps {
  iconSize?: IRewindIconProps['size'];
  seconds?: number;
  onClick: (seconds: number) => void;
  className?: string;
}

const RewindControl = ({
  iconSize = IconSize.medium,
  seconds = BACKWARD_SHORTCUT_SECONDS,
  onClick,
  className,
}: IRewindControlProps) => {
  const { t } = useTranslation('common');

  return (
    <TooltipWrapper
      tooltipText={t('tooltips.rewind', {
        seconds_value: seconds,
      })}
      tooltipPosition='top'
    >
      <IconButton
        className={className}
        onClick={() => onClick(seconds)}
        icon={<RewindIcon size={iconSize}>{seconds}</RewindIcon>}
      />
    </TooltipWrapper>
  );
};

export default RewindControl;
